import * as Yup from 'yup';
import CONSTANTS from '../constants';
import { DISABLE_CAPTCHA } from '../utils/features';

export const signInValidationSchema = Yup.object({
	username: Yup.string('Please enter your user name.').required(
		'User name is required!'
	),
	password: Yup.string('Please enter your password.').required(
		'Password is required!'
	),
	captchaToken: DISABLE_CAPTCHA
		? Yup.string()
		: Yup.string().required('Please complete the security check.'),
});

const multiFieldSchema = Yup.object({
	value: Yup.number().required('Please enter the value!'),
	unit: Yup.string()
		.required('Please enter the unit!')
		.oneOf(CONSTANTS.dateUnitList, 'The chosen unit is not valid!'),
});

const purposeSchema = Yup.object().shape({
	code: Yup.string().required('Code is required'),
	text: Yup.string().required('Purpose text is required!'),
	refUri: Yup.string().required('RefUri is required'),
	Category: Yup.object().shape({
		type: Yup.string().required('Category type is required'),
	}),
});

export const dataFilterSchema = Yup.object().shape({
	type: Yup.string().oneOf(
		CONSTANTS.dataFilterTypes,
		'The chosen type is not valid!'
	),
	operator: Yup.string().oneOf(
		CONSTANTS.dataFilterOperators,
		'The chosen operator is not valid!'
	),
	value: Yup.string(),
});

export const consentRequestSchema = Yup.object({
	customerId: Yup.string().trim().required('Customer ID is required!'),
	consentDesc: Yup.string()
		.trim()
		.required('Consent Description is required!')
		.matches('^[a-zA-Z0-9 .]+$', 'Only alphanumeric characters are allowed!'),
	template: Yup.string().required('Please choose atleast one template!'),
	purpose: purposeSchema,
	consentMode: Yup.string()
		.required('Please choose one the modes of raising consent request!')
		.oneOf(CONSTANTS.consentModeList, 'The chosen consent mode is not valid!'),
	fiType: Yup.array()
		.of(Yup.string())
		.min(1, 'Please provide atleast one FI Type!'),
	consentType: Yup.array()
		.of(Yup.string())
		.min(1, 'Please select at least one option')
		.required('Please select at least one option'),
	frequency: Yup.string()
		.oneOf(['PERIODIC', 'ONETIME'])
		.required('Please select the frequency of consent request!'),
	frequencyPeriod: Yup.object({
		value: Yup.number().required('Please enter the value!'),
		unit: Yup.string()
			.required('Please enter the unit!')
			.oneOf(CONSTANTS.frequencyUnitList, 'The chosen unit is not valid!'),
	}),
	consentStart: Yup.object({
		value: Yup.number().required('Please enter the value!'),
		unit: Yup.string()
			.default('DAY'),
	}),
	consentExpiry: multiFieldSchema,
	dataFilter: dataFilterSchema,
	dataLife: multiFieldSchema,
	dataRange: Yup.object({
		value: Yup.number().required('Please enter the value!'),
		unit: Yup.string()
			.default(0)
			.required('Please enter the unit!')
			.oneOf(CONSTANTS.dataRangeList, 'The chosen unit is not valid!'),
	}),
});
// export const trackRequestSchema = Yup.object({
//   customerId: Yup.string().required('Customer ID is required!'),
//   requestDate: Yup.string('Please enter a valid date!').required(
//     'Please enter the date!'
//   ),
// });

export const editPasswordSchema = Yup.object({
  password: Yup.string()
  		.trim()
  		.required("Please enter the password!"),
  newPassword: Yup.string()
		.min(8, 'Password must be atleast 8 characters long!')
		.matches(
			/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
			'Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character'
		)
		.required('Password is required!'),
	confirmPassword: Yup.string()
		.oneOf([Yup.ref('newPassword'), null], 'Passwords must match!')
		.required('Confirming password is required!'),
});

export const viewConsentSchema = Yup.object({
	customerId: Yup.string().required('Customer ID is required!'),
});

export const createUserSchema = Yup.object().shape({
	userId: Yup.string()
		.required('User ID is required!')
		.matches(
			'^[a-zA-Z0-9_]+$',
			'Only alphanumeric characters, underscore or hyphen are allowed!'
		),
	userName: Yup.string().required('User name is required!'),
	password: Yup.string()
		.min(8, 'Password must be atleast 8 characters long!')
		.matches(
			/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
			'Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character'
		)
		.required('Password is required!'),
	confirmPassword: Yup.string()
		.oneOf([Yup.ref('password'), null], 'Passwords must match!')
		.required('Confirming password is required!'),
	userRole: Yup.string().required('User role is required!'),
});

export const createUserRoleSchema = Yup.object().shape({
	roleName: Yup.string()
		.required('Role name is required!')
		.matches(
			'^[a-zA-Z0-9_]+$',
			'Only alphanumeric characters, underscore or hyphen are allowed!'
		),
	roleDescription: Yup.string().required('Role description is required!'),
	permissionGroupList: Yup.array()
		.of(Yup.string())
		.required('At least one permission group is required')
		.min(1, 'At least one permission group is required'),
});

export const consentTemplateSchema = Yup.object({
	templateName: Yup.string()
		.required('Template name is required!')
		.matches(
			'^[a-zA-Z0-9_]+$',
			'Only alphanumeric characters, underscore or hyphen are allowed!'
		),
	templateDescription: Yup.string()
		.trim()
		.required('Consent Description is required!')
		.matches('^[a-zA-Z0-9 .]+$', 'Only alphanumeric characters are allowed!'),
	purpose: purposeSchema,
	consentMode: Yup.string()
		.required('Please choose one the modes of raising consent request!')
		.oneOf(CONSTANTS.consentModeList, 'The chosen consent mode is not valid!'),
	fiTypes: Yup.array()
		.of(Yup.string())
		.min(1, 'Please provide atleast one FI Type!'),
	consentType: Yup.array()
		.of(Yup.string())
		.min(1, 'Please select at least one option')
		.required('Please select at least one option'),
	frequency: Yup.string()
		.oneOf(['PERIODIC', 'ONETIME'])
		.required('Please select the frequency of consent request!'),
	frequencyPeriod: Yup.object({
		value: Yup.number().required('Please enter the value!'),
		unit: Yup.string()
			.required('Please enter the unit!')
			.oneOf(CONSTANTS.frequencyUnitList, 'The chosen unit is not valid!'),
	}),
	consentStart: Yup.string()
		.trim()
		.required('Please enter the number of days!'),
	consentExpiry: multiFieldSchema,
	dataLife: multiFieldSchema,
	dataRange: Yup.object({
		value: Yup.number().required('Please enter the value!'),
		unit: Yup.string()
			.required('Please enter the unit!')
			.oneOf(CONSTANTS.dataRangeList, 'The chosen unit is not valid!'),
	}),
	dataFilter: Yup.object().shape({
		type: Yup.string()
			.required('Type is required!')
			.oneOf(CONSTANTS.dataFilterTypes, 'The chosen type is not valid!'),
		operator: Yup.string()
			.required('Operator is required!')
			.oneOf(
				CONSTANTS.dataFilterOperators,
				'The chosen operator is not valid!'
			),
		value: Yup.string().required('Value is required!'),
	}),
});
